/**
 * A stable sheet width for this tab's dialogs on a phone.
 *
 * `ModalBox` asks for `w-full`, but between it and the centred overlay sits an
 * unstyled wrapper that shrinks to fit its content, so the percentage resolves
 * against the dialog's own contents rather than the viewport: a phone gets a
 * box only as wide as its longest line, and the New poll form visibly grows
 * sideways with every option added. An explicit width sidesteps the percentage
 * and lands on the same figure `ModalBox` already caps these dialogs at.
 *
 * Passed as `wrapper-classes` rather than fixed in `ModalBox`, because that
 * component is shared with the rest of the dashboard.
 */
export const MOBILE_SHEET_WIDTH = 'max-lg:w-[calc(100vw_-_2rem)]'
